import { HomeOutlined } from '@material-ui/icons'
import React from 'react'
import { CardInfo, CardInfoProps } from '../../../../../../../components/shared/cardInfo/cardInfo'
import { LoadingCard } from '../../../../../../../components/shared/loadingCard/loadingCard'

interface LeadInfoCardProps extends CardInfoProps {}

export const LeadInfoCard: React.FC<LeadInfoCardProps> = ({
  isLoading,
  withTransition,
  info,
  displayInfoKeys = false,
  avatarIcon,
  title,
  subtitle,
  titleVariant = 'primary',
  headerActions,
  footerActions,
  ...props
}) => {
  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return isLoading ? (
    <LoadingCard />
  ) : (
    <CardInfo
      avatarIcon={<HomeOutlined />}
      withTransition={true}
      info={info}
      title={title}
      titleVariant={'primary'}
      subtitle={subtitle}
      headerActions={headerActions}
      footerActions={footerActions}
      {...props}
    />
  )
}
